import { toSVG } from '@carbon/icon-helpers';
import IconDescriptor from '@carbon/icon-helpers/lib/types';
import AddAlt16 from '@carbon/icons/es/add--alt/16';
import AddComment16 from '@carbon/icons/es/add-comment/16';
import Add16 from '@carbon/icons/es/add/16';
import Alarm16 from '@carbon/icons/es/alarm/16';
import ArrowDownRight16 from '@carbon/icons/es/arrow--down-right/16';
import ArrowDown16 from '@carbon/icons/es/arrow--down/16';
import ArrowLeft16 from '@carbon/icons/es/arrow--left/16';
import ArrowRight16 from '@carbon/icons/es/arrow--right/16';
import ArrowUp16 from '@carbon/icons/es/arrow--up/16';
import ArrowsHorizontal16 from '@carbon/icons/es/arrows--horizontal/16';
import ArrowsVertical16 from '@carbon/icons/es/arrows--vertical/16';
import Book16 from '@carbon/icons/es/book/16';
import Bullhorn16 from '@carbon/icons/es/bullhorn/16';
import Calendar16 from '@carbon/icons/es/calendar/16';
import Camera16 from '@carbon/icons/es/camera/16';
import CaretDown16 from '@carbon/icons/es/caret--down/16';
import CaretRight16 from '@carbon/icons/es/caret--right/16';
import CaretSortDown16 from '@carbon/icons/es/caret--sort--down/16';
import CaretUp16 from '@carbon/icons/es/caret--up/16';
import Catalog16 from '@carbon/icons/es/catalog/16';
import CenterCircle16 from '@carbon/icons/es/center--circle/16';
import CenterSquare16 from '@carbon/icons/es/center--square/16';
import CenterToFit16 from '@carbon/icons/es/center-to-fit/16';
import ChangeCatalog16 from '@carbon/icons/es/change-catalog/16';
import Chart_3D16 from '@carbon/icons/es/chart--3D/16';
import ChartVennDiagram16 from '@carbon/icons/es/chart--venn-diagram/16';
import Chat16 from '@carbon/icons/es/chat/16';
import CheckmarkFilled16 from '@carbon/icons/es/checkmark--filled/16';
import Checkmark16 from '@carbon/icons/es/checkmark/16';
import ChevronDown16 from '@carbon/icons/es/chevron--down/16';
import ChevronLeft16 from '@carbon/icons/es/chevron--left/16';
import ChevronRight16 from '@carbon/icons/es/chevron--right/16';
import ChevronSortDown16 from '@carbon/icons/es/chevron--sort--down/16';
import ChevronUp16 from '@carbon/icons/es/chevron--up/16';
import CircleFilled16 from '@carbon/icons/es/circle--filled/16';
import Clean16 from '@carbon/icons/es/clean/16';
import Close16 from '@carbon/icons/es/close/16';
import CloudUpload16 from '@carbon/icons/es/cloud--upload/16';
import CloudSatellite16 from '@carbon/icons/es/cloud-satellite/16';
import ColorPalette16 from '@carbon/icons/es/color-palette/16';
import Compare16 from '@carbon/icons/es/compare/16';
import Connect16 from '@carbon/icons/es/connect/16';
import ContinueFilled16 from '@carbon/icons/es/continue--filled/16';
import Contrast16 from '@carbon/icons/es/contrast/16';
import CopyFile16 from '@carbon/icons/es/copy--file/16';
import Copy16 from '@carbon/icons/es/copy/16';
import Crop16 from '@carbon/icons/es/crop/16';
import CubeView16 from '@carbon/icons/es/cube-view/16';
import Cube16 from '@carbon/icons/es/cube/16';
import CutOut16 from '@carbon/icons/es/cut-out/16';
import Cut16 from '@carbon/icons/es/cut/16';
import Dashboard16 from '@carbon/icons/es/dashboard/16';
import DataBase16 from '@carbon/icons/es/data--base/16';
import DataCheck16 from '@carbon/icons/es/data--check/16';
import DataView16 from '@carbon/icons/es/data--view/16';
import DataTable16 from '@carbon/icons/es/data-table/16';
import DocumentBlank16 from '@carbon/icons/es/document--blank/16';
import DocumentDownload16 from '@carbon/icons/es/document--download/16';
import DocumentExport16 from '@carbon/icons/es/document--export/16';
import DocumentImport16 from '@carbon/icons/es/document--import/16';
import DocumentSubtract16 from '@carbon/icons/es/document--subtract/16';
import DocumentView16 from '@carbon/icons/es/document--view/16';
import Document16 from '@carbon/icons/es/document/16';
import DotMark16 from '@carbon/icons/es/dot-mark/16';
import DownToBottom16 from '@carbon/icons/es/down-to-bottom/16';
import Download16 from '@carbon/icons/es/download/16';
import Draggable16 from '@carbon/icons/es/draggable/16';
import Edit16 from '@carbon/icons/es/edit/16';
import Email16 from '@carbon/icons/es/email/16';
import ErrorFilled16 from '@carbon/icons/es/error--filled/16';
import ErrorOutline16 from '@carbon/icons/es/error--outline/16';
import Error16 from '@carbon/icons/es/error/16';
import Fade20 from '@carbon/icons/es/fade/20';
import FilterEdit16 from '@carbon/icons/es/filter--edit/16';
import FilterReset16 from '@carbon/icons/es/filter--reset/16';
import Filter16 from '@carbon/icons/es/filter/16';
import FitToScreen16 from '@carbon/icons/es/fit-to-screen/16';
import FlowData16 from '@carbon/icons/es/flow--data/16';
import Flow16 from '@carbon/icons/es/flow/16';
import Folder16 from '@carbon/icons/es/folder/16';
import Group16 from '@carbon/icons/es/group/16';
import Help16 from '@carbon/icons/es/help/16';
import InformationFilled16 from '@carbon/icons/es/information--filled/16';
import Information16 from '@carbon/icons/es/information/16';
import Insert16 from '@carbon/icons/es/insert/16';
import Launch16 from '@carbon/icons/es/launch/16';
import ListBulleted16 from '@carbon/icons/es/list--bulleted/16';
import ListNumbered16 from '@carbon/icons/es/list--numbered/16';
import Locked16 from '@carbon/icons/es/locked/16';
import Logout16 from '@carbon/icons/es/logout/16';
import MagicWandFilled16 from '@carbon/icons/es/magic-wand--filled/16';
import Maximize16 from '@carbon/icons/es/maximize/16';
import ModelBuilder16 from '@carbon/icons/es/model-builder/16';
import Move16 from '@carbon/icons/es/move/16';
import Notebook16 from '@carbon/icons/es/notebook/16';
import Notification16 from '@carbon/icons/es/notification/16';
import OverflowMenuHorizontal16, {
  default as OverflowHorizontal16,
} from '@carbon/icons/es/overflow-menu--horizontal/16';
import OverflowMenuVertical16 from '@carbon/icons/es/overflow-menu--vertical/16';
import PaintBrush16 from '@carbon/icons/es/paint-brush/16';
import PauseOutline16 from '@carbon/icons/es/pause--outline/16';
import PauseFuture16 from '@carbon/icons/es/pause-future/16';
import Person16 from '@carbon/icons/es/person/16';
import PlayFilled16 from '@carbon/icons/es/play--filled/16';
import Portfolio16 from '@carbon/icons/es/portfolio/16';
import RecentlyViewed16 from '@carbon/icons/es/recently-viewed/16';
import Renew16 from '@carbon/icons/es/renew/16';
import Report16 from '@carbon/icons/es/report/16';
import ResetAlt16 from '@carbon/icons/es/reset--alt/16';
import Reset16 from '@carbon/icons/es/reset/16';
import RetryFailed16 from '@carbon/icons/es/retry--failed/16';
import RotateClockwiseAltFilled16 from '@carbon/icons/es/rotate--clockwise--alt--filled/16';
import RotateClockwise16 from '@carbon/icons/es/rotate--clockwise/16';
import RotateCounterclockwise16 from '@carbon/icons/es/rotate--counterclockwise/16';
import Rss16 from '@carbon/icons/es/rss/16';
import RulerAlt16 from '@carbon/icons/es/ruler--alt/16';
import Ruler16 from '@carbon/icons/es/ruler/16';
import Scale16 from '@carbon/icons/es/scale/16';
import Scales16 from '@carbon/icons/es/scales/16';
import ScatterMatrix16 from '@carbon/icons/es/scatter-matrix/16';
import Search16 from '@carbon/icons/es/search/16';
import { default as Select0116 } from '@carbon/icons/es/select--01/16';
import SendAlt16 from '@carbon/icons/es/send--alt/16';
import SendFilled16 from '@carbon/icons/es/send--filled/16';
import Send16 from '@carbon/icons/es/send/16';
import Settings16 from '@carbon/icons/es/settings/16';
import ShapeExcept16 from '@carbon/icons/es/shape--except/16';
import Share16 from '@carbon/icons/es/share/16';
import ShoppingCatalog16 from '@carbon/icons/es/shopping--catalog/16';
import { default as CollapseSidenav16 } from '@carbon/icons/es/side-panel--close--filled/16';
import { default as CollapseSidenav216 } from '@carbon/icons/es/side-panel--close/16';
import { default as ExpandSidenav16 } from '@carbon/icons/es/side-panel--open--filled/16';
import { default as ExpandSidenav216 } from '@carbon/icons/es/side-panel--open/16';
import SkillLevelAdvanced16 from '@carbon/icons/es/skill-level--advanced/16';
import SprayPaint16 from '@carbon/icons/es/spray-paint/16';
import StopFilled16 from '@carbon/icons/es/stop--filled/16';
import SubtractAlt16 from '@carbon/icons/es/subtract--alt/16';
import Subtract16 from '@carbon/icons/es/subtract/16';
import { default as Support16 } from '@carbon/icons/es/support-vector-machine/16';
import TableSplit16 from '@carbon/icons/es/table--split/16';
import Table16 from '@carbon/icons/es/table/16';
import TagGroup16 from '@carbon/icons/es/tag--group/16';
import Tag16 from '@carbon/icons/es/tag/16';
import TaskView16 from '@carbon/icons/es/task--view/16';
import Task16 from '@carbon/icons/es/task/16';
import TextHighlight16 from '@carbon/icons/es/text--highlight/16';
import { default as Thumbnail16 } from '@carbon/icons/es/thumbnail--2/16';
import Time16 from '@carbon/icons/es/time/16';
import TrashCan16 from '@carbon/icons/es/trash-can/16';
import { default as EmptyStateAddObjectDark16 } from '@carbon/icons/es/unknown/16';
import Unlocked16 from '@carbon/icons/es/unlocked/16';
import Upload16 from '@carbon/icons/es/upload/16';
import UserActivity16 from '@carbon/icons/es/user--activity/16';
import UserAdmin16 from '@carbon/icons/es/user--admin/16';
import UserAvatar16 from '@carbon/icons/es/user--avatar/16';
import UserMultiple16 from '@carbon/icons/es/user--multiple/16';
import User16 from '@carbon/icons/es/user/16';
import ViewFilled16 from '@carbon/icons/es/view--filled/16';
import ViewOff16 from '@carbon/icons/es/view--off/16';
import View16 from '@carbon/icons/es/view/16';
import WarningAltFilled16 from '@carbon/icons/es/warning--alt--filled/16';
import WarningAlt16 from '@carbon/icons/es/warning--alt/16';
import WarningFilled16 from '@carbon/icons/es/warning--filled/16';
import Warning16 from '@carbon/icons/es/warning/16';
import WatsonHealth3DMprToggle16 from '@carbon/icons/es/watson-health/3D-MPR-Toggle/16';
import WatsonHealth3DCursorAlt16 from '@carbon/icons/es/watson-health/3D-cursor--alt/16';
import WatsonHealthCdCreateExchange16 from '@carbon/icons/es/watson-health/cd--create-exchange/16';
import { default as CircleMeasurement16 } from '@carbon/icons/es/watson-health/circle-measurement/32';
import { default as CutInHalf16 } from '@carbon/icons/es/watson-health/cut-in-half/32';
import { default as Rotate36016 } from '@carbon/icons/es/watson-health/rotate--360/32';
import { default as SubVolume16 } from '@carbon/icons/es/watson-health/sub-volume/16';
import ZAxis16 from '@carbon/icons/es/z-axis/16';

type CarbonIconDescriptor = IconDescriptor & {
  name: string;
};

/**
 * Sourced from 'node_modules/@carbon/icons/lib/index.js'.
 * Note that the px size (16, 20, 24, 32) will be overridden by
 * MatIconRegistry and subsequently does not matter.
 * See icon-registry.ts::_setSvgAttributes for implementation details.
 */
export const icons16: CarbonIconDescriptor[] = [
  FilterEdit16,
  Dashboard16,
  Portfolio16,
  Settings16,
  Flow16,
  UserMultiple16,
  TableSplit16,
  Send16,
  Task16,
  TaskView16,
  Book16,
  Tag16,
  ArrowsHorizontal16,
  ArrowLeft16,
  Upload16,
  Renew16,
  PauseOutline16,
  Add16,
  Information16,
  DataCheck16,
  Document16,
  DocumentBlank16,
  DocumentDownload16,
  Close16,
  Download16,
  ChevronDown16,
  ChevronRight16,
  Draggable16,
  Search16,
  ChevronUp16,
  Edit16,
  DownToBottom16,
  AddAlt16,
  Chat16,
  Alarm16,
  SendFilled16,
  InformationFilled16,
  RecentlyViewed16,
  Checkmark16,
  Logout16,
  DotMark16,
  OverflowMenuHorizontal16,
  OverflowMenuVertical16,
  Filter16,
  ArrowLeft16,
  ArrowRight16,
  Error16,
  Calendar16,
  ChevronSortDown16,
  Time16,
  Clean16,
  ChevronLeft16,
  ArrowsHorizontal16,
  WarningFilled16,
  DataBase16,
  ArrowUp16,
  ArrowDown16,
  ArrowDownRight16,
  UserAvatar16,
  TrashCan16,
  CaretRight16,
  View16,
  ViewFilled16,
  ViewOff16,
  CenterCircle16,
  CircleFilled16,
  WatsonHealth3DMprToggle16,
  AddComment16,
  CaretDown16,
  CaretUp16,
  CenterToFit16,
  ChartVennDiagram16,
  CircleMeasurement16,
  ColorPalette16,
  Contrast16,
  Crop16,
  CubeView16,
  Cut16,
  CutInHalf16,
  CutOut16,
  ErrorFilled16,
  FilterReset16,
  FitToScreen16,
  Insert16,
  Locked16,
  MagicWandFilled16,
  ModelBuilder16,
  OverflowHorizontal16,
  PaintBrush16,
  Reset16,
  ResetAlt16,
  RotateClockwiseAltFilled16,
  Rss16,
  Ruler16,
  Select0116,
  ShapeExcept16,
  Share16,
  ShoppingCatalog16,
  SkillLevelAdvanced16,
  SprayPaint16,
  Subtract16,
  SubVolume16,
  TextHighlight16,
  WatsonHealth3DCursorAlt16,
  RotateClockwise16,
  RotateCounterclockwise16,
  SubtractAlt16,
  Copy16,
  CloudSatellite16,
  CloudUpload16,
  Help16,
  Warning16,
  EmptyStateAddObjectDark16,
  Catalog16,
  ChangeCatalog16,
  ZAxis16,
  Maximize16,
  TagGroup16,
  WarningAlt16,
  WarningAltFilled16,
  ListNumbered16,
  Launch16,
  Notebook16,
  CheckmarkFilled16,
  Scales16,
  RulerAlt16,
  DocumentExport16,
  DocumentImport16,
  SendAlt16,
  User16,
  UserActivity16,
  CaretSortDown16,
  ScatterMatrix16,
  DocumentSubtract16,
  DocumentView16,
  ArrowsVertical16,
  Support16,
  Thumbnail16,
  Notification16,
  Move16,
  Cube16,
  Chart_3D16,
  FlowData16,
  Connect16,
  Rotate36016,
  Scale16,
  Person16,
  CenterSquare16,
  Camera16,
  WatsonHealthCdCreateExchange16,
  ErrorOutline16,
  Unlocked16,
  Report16,
  Group16,
  Bullhorn16,
  CollapseSidenav16,
  CollapseSidenav216,
  ExpandSidenav16,
  ExpandSidenav216,
  DataTable16,
  Table16,
  DataView16,
  ListBulleted16,
  Email16,
  Folder16,
  PlayFilled16,
  ContinueFilled16,
  PauseFuture16,
  StopFilled16,
  Fade20,
  RetryFailed16,
  Compare16,
  CopyFile16,
  UserAdmin16,
];

// create a function to get svg string from carbon icon based on provided name
export function getCarbonIconSvgString(iconName: string): string | undefined {
  const icon = icons16.find(icon => icon.name === iconName);
  return icon ? toSVG(icon).outerHTML : undefined;
}
